<template>
  <div class="offers">
    <div
      :class="[
        'head',
        router.currentRoute.path === '/visabenefits' ? 'benefit-head' : 'offer-head',
      ]"
    >
      <p>
        <span>{{ $t(description.title) }}</span>
      </p>
      <div>{{ $t(description.title) }}</div>
    </div>

    <div class="desc">
      <div class="title">
        <h3>{{ $t(description.subtitle) }}</h3>
      </div>
      <p class="ctn1">{{ $t(description.desc1) }}</p>
      <div>
        <a :href="pdf" target="_blank">{{ $t(description.desc2) }} </a>
        <span> {{ $t(description.desc3) }}</span>
      </div>
    </div>

    <div class="main">
      <div class="tab-bar">
        <ul v-if="tabList.length < 5">
          <li
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ active: currentIndex === index }"
            @click="handleClick(item, index)"
          >
            {{ item.title }}
          </li>
        </ul>
        <ul class="more-tab" v-else>
          <li
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ active: currentIndex === index }"
            @click="handleClick(item, index)"
          >
            {{ item.title }}
          </li>
        </ul>
      </div>

      <div class="filter-tool">
        <div class="search-input-wrapper">
          <input
            id="area-code"
            type="text"
            class="search-input"
            autocomplete="new-password"
            v-model="searchText"
            :placeholder="$t('views-bo-Search')"
            @keyup.enter="handleSearch"
            @input="handleSearch"
          />
          <img
            class="icon-search"
            src="~img/search-Icon.png"
            alt="search area code"
            @click="handleSearch"
          />
        </div>

        <div class="location">
          <div class="select-box-lc">
            <select-box
              ref="location"
              :listData="filterLocationData"
              @handleListItemSelect="handleSelectLocation"
              @toggleDropDownList="toggleLocationDropDownList"
            >
              <template v-slot:default>
                <div class="select-name">{{ currentSelectLocation }}</div>
              </template>
              <template v-slot:itemDesc="slotItem">{{ slotItem.item }}</template>
            </select-box>
          </div>

          <div class="select-box-st">
            <select-box
              ref="sort"
              :listData="filterSortData"
              @handleListItemSelect="handleSelectSort"
              @toggleDropDownList="toggleNewDropDownList"
            >
              <template v-slot:default>
                <div class="select-name">{{ currentSelectSort }}</div>
              </template>
              <template v-slot:itemDesc="slotItem">{{ slotItem.item }}</template>
            </select-box>
          </div>
        </div>
      </div>

      <div class="cards">
        <cards
          v-if="cardData.cards && cardData.cards.length"
          :options="cardData"
          @cardClick="cardClick"
        >
        </cards>

        <div v-else class="no-match">
          <p>{{ $t('no-match-items') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cards from '@/components/BaseUi/AirportLoungeCards';
  import SelectBox from '@/components/BaseUi/SelectBox';
  import router from '@/router';
  let time = null;
  export default {
    components: {
      Cards,
      SelectBox,
    },

    props: {
      listData: {
        type: Array,
        default: () => [],
      },
      filterData: {
        type: Object,
        default: () => {},
      },
      description: {
        type: Object,
        default: () => {},
      },
      tabListData: {
        type: Array,
        default: () => [],
      },
    },

    watch: {
      listData: {
        handler(newval) {
          this.cardData.cards = newval.map(item => {
            item.details = item.name;
            return item;
          });
          console.log('this.cardData.cards', this.cardData.cards);
        },
        deep: true,
      },

      filterData: {
        handler(newval) {
          this.filterLocationData = newval.location;
          this.filterSortData = newval.sort;
          this.currentSelectLocation = newval.location[0];
          this.currentSelectSort = newval.sort[0];
        },
        deep: true,
      },

      tabListData: {
        handler(newval) {
          this.tabList = newval;
          this.currentTabName = this.tabList[0].title;
        },
      },
    },

    data() {
      return {
        router,
        currentIndex: 0,
        currentTabName: '',
        searchText: '',
        filterLocationData: [],
        filterSortData: [],
        currentSelectLocation: '',
        currentSelectSort: '',
        tabList: [],

        cardData: {
          useCardItemStyle: true,
          showDesc2: false,
          showName: false,
          cardHeadStyle: {
            display: 'none',
          },
          cardItemStyle: {
            width: '30%',
            marginBottom: '45px',
          },
          cards: [],
        },
      };
    },

    methods: {
      resetPlaceholder(e) {
        e.target.placeholder = 'asd';
      },
      toggleLocationDropDownList() {
        this.$refs.sort.showdropDownList = false;
      },
      toggleNewDropDownList() {
        this.$refs.location.showdropDownList = false;
      },
      handleClick(item, index) {
        // 点击切换tab时，初始化数据
        this.currentIndex = index;
        this.currentTabName = item.title;
        this.searchText = '';
        this.currentSelectLocation = this.filterLocationData[0];
        this.currentSelectSort = this.filterSortData[0];
        this.handleSearch();
      },

      handleSelectLocation(data) {
        this.currentSelectLocation = this.filterLocationData[data[1]];
        this.handleSearch();
      },

      handleSelectSort(data) {
        this.currentSelectSort = this.filterSortData[data[1]];
        this.handleSearch();
      },

      handleSearch() {
        clearTimeout(time);
        const data = this.getParams();
        time = setTimeout(() => {
          this.$emit('search', data);
        }, 500);
      },

      getParams() {
        // currentTabName为null的情况下传一个null给后端即可
        // const categoryName =
        //   this.currentTabName === this.tabList[0].label ? 'null' : this.currentTabName;
        const data = {
          category: this.currentTabName,
          location: this.currentSelectLocation,
          sort: this.currentSelectSort,
          search: this.searchText,
        };
        return data;
      },

      cardClick(data) {
        // 跳转至 offer详情页
        data.kind === 1 &&
          this.$router.push({ path: '/offer/details', query: { vmorcId: data.vmorcId } });
        // 跳转至 benefit详情页
        data.kind === 2 &&
          this.$router.push({ path: '/benefit/details', query: { vmorcId: data.vmorcId } });
      },
    },

    computed: {
      pdf() {
        /*
          visa 在线PDF
          https://www.visainfinite.ca/content/dam/canadaimages/vids/VIDS_Latest_Series_EN.pdf
          https://www.visainfinite.ca/content/dam/canadaimages/vids/VIDS_Latest_Series_FR.pdf
        */
        // return this.$i18n.locale === 'fr_CA'
        //   ? require('../../../assets/pdf/VIDS_Latest_Series_FR.pdf')
        //   : require('../../../assets/pdf/VIDS_Latest_Series_EN.pdf');
        if (this.$i18n.locale === 'en_US')
          return 'https://www.visainfinite.ca/infinite/en/home.html?category=foodWineLink';
        return 'https://www.visainfinite.ca/infinite/fr/accueil.html?category=foodWineLink';
      },
    },
  };
</script>

<style scoped lang="scss">
  @import './index';
</style>
